import { render, staticRenderFns } from "./registration-modal.vue?vue&type=template&id=7e626f6e&lang=pug"
import script from "./registration-modal.vue?vue&type=script&lang=ts"
export * from "./registration-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@locales/de/de.yml?namespace=ui.components.users.onboarding?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fbase%2Fregistration-modal.vue&locale=de&lang=yaml&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@locales/en/en.yml?namespace=ui.components.users.onboarding?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fbase%2Fregistration-modal.vue&locale=en&lang=yaml&external"
if (typeof block1 === 'function') block1(component)

export default component.exports